import Vue from "vue";
import { wencesApi } from "@/api/wencesApi";

/**
 * Etiquetas de la lista «currency» del tenant, para mostrar una moneda que llega solo como
 * id (p. ej. un importe con moneda fija, ticket #397) cuando la vista no trae las listas.
 * Una sola consulta por carga de página; es reactivo: lo que se pinta antes de que llegue
 * se actualiza solo.
 */
const state = Vue.observable({ labels: {}, loaded: false });
let loading = null;

const OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

function load() {
  if (loading) return loading;
  loading = wencesApi
    .get("/api/gotrading/lists")
    .then(({ data }) => {
      const lists = Array.isArray(data) ? data : [];
      const currency = lists.find((l) => l && l.type === "currency");
      const labels = {};
      for (const v of (currency && currency.values) || []) {
        if (v && v._id) labels[String(v._id)] = String(v.label || v.name || "");
      }
      state.labels = labels;
      state.loaded = true;
    })
    .catch(() => {
      loading = null;
    });
  return loading;
}

/** ¿Parece un id de MongoDB? (para no mostrarlo como si fuera el nombre de la moneda) */
export function looksLikeObjectId(value) {
  return OBJECT_ID_RE.test(String(value || ""));
}

/**
 * Etiqueta de una moneda por id; "" mientras no se cargó (y dispara la carga).
 * @param {string} currencyId
 */
export function currencyLabelFor(currencyId) {
  const id = String(currencyId || "");
  if (!id) return "";
  const label = state.labels[id];
  if (label === undefined && !state.loaded) load();
  return label || "";
}
